_       = require('underscore')
LatLng  = require('./lat_lng')

module.exports = class CountryPolygon

  constructor: (options = {}) ->
    @util         = options.util
    @country      = options.country
    @coordinates  = _.map options.coordinates, (latLng) -> LatLng(latLng.lat, latLng.lng)
    @active       = options.active
    @ctx          = @util.context
    @_coordinates = _.map @coordinates, (coord) -> [coord.lng, coord.lat]

  getFillStyle: ->
    if @active == true
      if @country.hovered == true then '#ef885d' else '#ea662f'
    else
      if @country.hovered == true then '#7a807f' else '#707675'

  getStrokeStyle: ->
    '#ffffff'

  render: ->
    first = true

    @ctx.save()
    @ctx.fillStyle    = @getFillStyle()
    @ctx.strokeStyle  = @getStrokeStyle()
    @ctx.lineWidth    = 1
    @ctx.beginPath()

    _.each @coordinates, (latLng) =>
      coord = @util.latLngToCoordinates(latLng)

      if first
        first = false
        @ctx.moveTo(coord.x, coord.y)
      else
        @ctx.lineTo(coord.x, coord.y)

    @ctx.closePath()
    @ctx.fill()
    @ctx.stroke()
    @ctx.restore()

  isLatLngInside: (latLng) ->
    require('./point_in_polygon')([latLng.lng, latLng.lat], @_coordinates)




// WEBPACK FOOTER //
// ./assets/js/frontend/components/countries_map/components/map/country_polygon.coffee